import { Flex, Text } from "@jsq/ds/core";
import { useDataStructureRoutingContext } from "~/pages/Reporting/DataStructureRoutingContext";
import { DataPackagesList } from "./DataPackagesList";

export type { DataStructureTabId, PackageTab, ViewFilter } from "./types";
export { VALID_DATA_STRUCTURE_TABS, VALID_VIEW_FILTERS, VIEW_FILTER_OPTIONS } from "./types";
export { DataStructureSidebar } from "./DataStructureSidebar";

export type DataStructureProps = {
  arenaId: number | null;
  arenaName?: string;
};

export const DataStructure = ({ arenaId, arenaName }: DataStructureProps) => {
  const { dataStructureType: activeType } = useDataStructureRoutingContext();

  const renderContent = () => {
    switch (activeType) {
      case "gl":
        return (
          <DataPackagesList title="GL data packages" arenaId={arenaId} arenaName={arenaName} />
        );
      case "gpx":
        return (
          <Flex alignItems="center" justifyContent="center" flexGrow={1}>
            <Text variant="regular-md">Nothing here yet, come back later</Text>
          </Flex>
        );
      case "date-ranges":
      case "primary-fields":
        return (
          <Flex alignItems="center" justifyContent="center" flexGrow={1}>
            <Text variant="regular-md">Coming soon</Text>
          </Flex>
        );
    }
  };

  return (
    <Flex flexDirection="column" flexGrow={1}>
      {renderContent()}
    </Flex>
  );
};
